module.exports = __webpack_public_path__ + "static/w_nubank-bd972620140b875fac9e15ba7b4eaf54.png";